import IsNullOrUndefined from "../utils/ObjectUtils";

export const RulesUtility = {

    findFirstAvailableFeature: (category, possibleFeatures) => {
        let firstAvailableFeature = undefined;
        possibleFeatures.forEach(possibleFeature => {
           const foundFeatureInConfig = category.features.find(f => f.id === possibleFeature);
           if (!IsNullOrUndefined(foundFeatureInConfig) && foundFeatureInConfig.disabled !== true && IsNullOrUndefined(firstAvailableFeature)) {
               firstAvailableFeature = possibleFeature;
           }
        });

        return firstAvailableFeature;
    },
    validatesCombination: (combination, categories, changedCategory, changedFeature) => {
        let isCombinationValid = true;
        let countFailures = 0;
        combination.group.forEach(group => {
            // Check rest of group validates

            if (group.categoryId !== changedCategory) {
                const foundCategoryInConfig = categories.find(c => c.id === group.categoryId);

                if (!IsNullOrUndefined(foundCategoryInConfig) && !foundCategoryInConfig.disabled) {
                    let selectedFeatureValidatesRule = false;
                    group.features.forEach(f => {
                        if (f === foundCategoryInConfig.selected_feature) {
                            selectedFeatureValidatesRule = true;
                        }
                    });

                    if(!selectedFeatureValidatesRule) {
                        isCombinationValid = false;
                        countFailures += 1;
                    }
                }
            } else {
                let selectedFeatureValidatesRule = false;
                group.features.forEach(f => {
                    if (f === changedFeature) {
                        selectedFeatureValidatesRule = true;
                    }
                });

                if(!selectedFeatureValidatesRule) {
                    isCombinationValid = false;
                    countFailures += 1000;
                }
            }
        });

        return countFailures;
    },
    applyFailedCombination: (combination, categories, changedCategory, addedCategoriesFromRule, removedCategoriesFromRule) => {
        combination.group.forEach(group => {
            if (group.categoryId !== changedCategory) {
                const foundCategoryInConfig = categories.find(c => c.id === group.categoryId);

                if (!IsNullOrUndefined(foundCategoryInConfig) && !foundCategoryInConfig.disabled) {
                    let selectedFeatureValidatesRule = false;
                    group.features.forEach(f => {
                        if (f === foundCategoryInConfig.selected_feature) {
                            selectedFeatureValidatesRule = true;
                        }
                    });

                    if(!selectedFeatureValidatesRule) {
                        const firstAvailableFeature = RulesUtility.findFirstAvailableFeature(foundCategoryInConfig, group.features);
                        removedCategoriesFromRule.push({...foundCategoryInConfig});
                        addedCategoriesFromRule.push({
                            ...foundCategoryInConfig,
                            selected_feature: firstAvailableFeature
                        });
                    }
                }
            }
        });
    },
    validateRules: (rules, categories, addedCategoriesFromRule, removedCategoriesFromRule, changedCategory, changedFeature) => {
        let isValid = true;

        rules.forEach(rule => {
            if (rule.categories.indexOf(changedCategory) !== -1)
            {
                let isRuleValid = false;
                let nearestFailedCombinationCountFailures = 10000;
                let nearestFailedCombination = null;
                // Loop combinations and find if any of them matches with current configuration
                rule.combinations.forEach(combination => {
                    const countFailures = RulesUtility.validatesCombination(combination, categories, changedCategory, changedFeature);
                    if (countFailures === 0) {
                        isRuleValid = true;
                    } else {
                        if (countFailures < nearestFailedCombinationCountFailures) {
                            nearestFailedCombination = combination;
                            nearestFailedCombinationCountFailures = countFailures;
                        }
                    }
                });

                if (!isRuleValid) {
                    // apply combination with nearestFailedCombination
                    RulesUtility.applyFailedCombination(nearestFailedCombination, categories, changedCategory, addedCategoriesFromRule, removedCategoriesFromRule);
                    isValid = false;
                }
            }
        });

        return isValid;
    }
    // NEW RULES LOGIC
    /* validateRules: (rules, categories, addedCategoriesFromRule, removedCategoriesFromRule, changedCategory, changedFeature) => {

        let isValid = true;

        rules.forEach(rule => {
            const foundGroup = rule.group.find(g => g.categoryId === changedCategory);
            if (!IsNullOrUndefined(foundGroup)) {
                if (foundGroup.features.find(f => f === changedFeature)) {
                    // Found category / feature in group
                    rule.group.forEach(group => {
                        // Check rest of group validates
                       if (group.categoryId !== changedCategory) {
                           const foundCategoryInConfig = categories.find(c => c.id === group.categoryId);

                           if (!IsNullOrUndefined(foundCategoryInConfig)) {
                               let selectedFeatureValidatesRule = false;
                               group.features.forEach(f => {
                                   if (f === foundCategoryInConfig.selected_feature) {
                                       selectedFeatureValidatesRule = true;
                                   }
                               });

                               if(!selectedFeatureValidatesRule) {
                                   removedCategoriesFromRule.push({...foundCategoryInConfig});
                                   addedCategoriesFromRule.push({
                                       ...foundCategoryInConfig,
                                       selected_feature: group.features[0]
                                   });

                                   isValid = false;
                               }
                           }
                       }
                    });
                }
            }
        });

        return isValid;
    }
    */
    // OLD RULES LOGIC
    /* validateGroup: (categoriesLogicalGroup, categories, changedCategory, changedFeature) => {
        let isValid = false;
        categoriesLogicalGroup.forEach(categoryLogicalGroup => {
            let category = categories.find(category => category.id === categoryLogicalGroup.categoryId);
            if(category.id === changedCategory)
            {
                category.selected_feature = changedFeature;
            }

            if (categoryLogicalGroup.featureId === category.selected_feature) {
                isValid = true;
            }
        });
        return isValid;
    },

    validateRules: (rules, categories, addedCategoriesFromRule, removedCategoriesFromRule, changedCategory, changedFeature) => {

        let isValid = true;

        rules.forEach(rule => {
            if ((rule.categoryId === changedCategory && rule.featureId === changedFeature)){
                let categoriesLogicalGroups = [];
                let counterLogicalGroups = 0;

                rule.rule.affects.forEach(affectedCategory => {
                    switch (affectedCategory.logic)
                    {
                        case "OR":
                        case undefined:
                            if(categoriesLogicalGroups[counterLogicalGroups] === undefined)
                            {
                                categoriesLogicalGroups.push([]);
                                categoriesLogicalGroups[counterLogicalGroups] = [];
                            }
                            break;
                        case "AND":
                            counterLogicalGroups = counterLogicalGroups + 1;
                            categoriesLogicalGroups.push([]);
                            categoriesLogicalGroups[counterLogicalGroups] = [];
                            break;
                    }
                    categoriesLogicalGroups[counterLogicalGroups].push(affectedCategory);
                });

                let tempCountLogicalGroups = 0;
                categoriesLogicalGroups.forEach(categoriesLogicalGroup => {
                    if(!RulesUtility.validateGroup(categoriesLogicalGroup, categories, changedCategory, changedFeature))
                    {
                        const categoryLogicalGroup = categoriesLogicalGroup[0];
                        let category = categories.find(category => category.id === categoryLogicalGroup.categoryId);

                        removedCategoriesFromRule.push({...category});
                        addedCategoriesFromRule.push({
                            ...category,
                            selected_feature: categoryLogicalGroup.featureId
                        });

                        isValid = false;
                    }

                    tempCountLogicalGroups++;
                });
            }
        });

        return isValid;
    } */
};
